import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, {} from "react";
import { Avatar, Button, Flex } from "antd";
import { dismissNotification } from "../../store/actions/notifications";
import { userHasPermission } from "../../swzutils/UserPermissionsUtil";
import { useAppDispatch, useAppSelector } from "../../store";
import { loggedInUserSelector } from "../../store/slice/auth";
import { Typography } from 'antd';
const { Title } = Typography;
const NotificationItem = (props) => {
    const dispatch = useAppDispatch();
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const dispatchNotificationDismiss = (id) => {
        dispatch(dismissNotification(id));
    };
    const links = [...props.links.filter(Boolean)];
    let dismissButton = undefined;
    if (userHasPermission(loggedInUser, ['admin:notification:dismissAny'])) {
        dismissButton = (_jsx(Button, { type: 'default', size: "small", onClick: () => dispatchNotificationDismiss(props.id), children: "Dismiss" }));
    }
    const itemLayout = window.innerWidth < 800 ? "vertical" : "horizontal";
    return (_jsxs(Flex, { orientation: itemLayout, justify: "space-between", children: [_jsxs(Flex, { orientation: "horizontal", justify: "flex-start", gap: "medium", children: [_jsx(Avatar, { shape: "square", icon: props.icon }), _jsxs(Flex, { orientation: "vertical", children: [_jsx(Title, { level: 5, children: props.title }), _jsx("p", { style: { margin: 0 }, children: props.description })] })] }), _jsxs(Flex, { orientation: "vertical", justify: "space-between", align: "end", gap: "small", children: [dismissButton, links.map((link, index) => _jsx("div", { children: link }, '' + index))] })] }));
};
export default NotificationItem;
